import { render, staticRenderFns } from "./statementItemList.vue?vue&type=template&id=5782e76a&scoped=true"
import script from "./statementItemList.vue?vue&type=script&lang=js"
export * from "./statementItemList.vue?vue&type=script&lang=js"
import style0 from "./statementItemList.vue?vue&type=style&index=0&id=5782e76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5782e76a",
  null
  
)

export default component.exports